import styled from 'styled-components'

export const TopicText = styled.div`
    font-size: 35px;
    color: #0a2980;
    letter-spacing: 5px;
    font-family: cintel;
    margin-left: 10px;
`
export const Line = styled.div`
    width: 100%;
    background-color: #fdd600;
    height: 2px;
`

export const DetailText = styled.div`
    font-size: 35px;
    color: #0a2980;
    font-family: cintel;
    margin: 5px 0 0 10px;
    letter-spacing: 3px;
`